import { getAll } from '../../api';

const state = {
  details: {},
  editKey: false, // modal boolean
};

const getters = {
  getDetails(state) {
    return state.details;
  },
  getEditKey(state) {
    return state.editKey;
  },
};

const actions = {
  acquireDetails: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/digitalkey?query=${
        encodeURIComponent(
          `{get(type_name: "digital_key", 
            digital_key: {uuid: "${payload}"}, 
            table_name:"${clientTable}"
          ){
            uuid, 
            code,
            phone,
            email,
            used,
            group_id,
            expected_return,
            error, 
            success
          }}`,
        )}`,
      payload,
    )
      .then((res) => {
        commit('setDetails', res.data.data.get[0]);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  editKey: async ({ dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    const newPayload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/digitalkey?query=${
        encodeURIComponent(
          `mutation{update(type_name: "digital_key", 
            digital_key: ${newPayload}, 
            table_name:"${clientTable}",
          ){
            uuid, 
            error, 
            success
          }}`,
        )}`,
      payload,
    )
      .then((res) => {
        dispatch('acquireDetails', res.data.data.update.uuid);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  }),
};

const mutations = {
  setDetails(state, payload) {
    state.details = payload;
  },
  setEditKey(state, payload) {
    state.editKey = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
